import { useLocation, Link, useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import "./style.css";
import { Divider, Dropdown, Layout, Menu, Tooltip } from "antd";
import { Drawer } from "antd";
import { FiMenu } from "react-icons/fi";
import HeaderLogo from "../../../../assets/images/HeaderLogo.png";
import { Avatar } from "antd";
import { FaBell } from "react-icons/fa";
import { IoIosSettings } from "react-icons/io";
import {
  CaretDownOutlined,
  CaretRightOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { IoMdPerson } from "react-icons/io";
import Colors from "../../../../config/colors";
import { IoLogOutSharp } from "react-icons/io5";
import { MdHomeFilled } from "react-icons/md";
import { RiFileTextLine } from "react-icons/ri";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { BiSolidCarGarage } from "react-icons/bi";
import { RiImageEditFill } from "react-icons/ri";
import { MdReviews } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  updateLoggedInUser,
  updateLoginStatus,
} from "../../../../store/common/authSlice";
import useAuthApi from "../../../../config/hooks/api/auth/useAuthApi";
import { signOut, getAuth } from "firebase/auth";
import { setAppLoading } from "../../../../store/common/generalSlice";
import { deleteSocketInstance } from "../../../../config/hooks/utility/socket";
import ChatUnreadMsgNotificationIcon from "../ChatUnreadMsgNotificationIcon";
import {
  resetChatStates,
  setNavigateToChannel,
} from "../../../../store/common/chatSlice";
import DownloadButton from "../../../FormElements/Button/Download";
import { getInitials, handleAdsExternalRedirect } from "../../../../config/utils";

const ServiceProviderHeader = () => {
  const { loggedInUser } = useSelector((state) => state?.auth);
  const { profileData } = useSelector((state) => state?.setting);
  const { unreadNotifications } = useSelector((state) => state?.general);

  const { Header } = Layout;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { logout } = useAuthApi();
  const auth = getAuth();

  const [drawerOpen, setDrawerOpen] = useState(false);

  // path is a state used here as for setting the active item.
  const [path, setPath] = useState("1");

  const drawerOpenHandler = () => {
    setDrawerOpen(true);
  };

  const homeRoutes = [
    {
      route: "/profile/:id",
    },
    // {
    //     route: "/quote-form"
    // },
    {
      route: "/serviceprovider/:id",
    },
    {
      route: "/serviceprovider/listView/:id",
    },
  ];

  const matchRoute = (routePattern) => {
    // Convert route pattern to a regex for dynamic segments
    const regexPattern = routePattern.replace(/:\w+/g, "[^/]+");
    const regex = new RegExp(`^${regexPattern}$`);
    return regex.test(location.pathname);
  };

  const handleLogout = async () => {
    try {
      dispatch(setAppLoading(true));

      const response = await logout();
      if (response) {
        if (loggedInUser && loggedInUser?.provider == "google")
          await signOut(auth);

        localStorage.removeItem("persist:root");
        localStorage.clear();
        deleteSocketInstance();

        dispatch(setAppLoading(false));
        dispatch(updateLoginStatus(false));
        dispatch(updateLoggedInUser(null));
        dispatch(resetChatStates());

        // localStorage.removeItem('hasUnreadMsgs')
      }
    } catch (error) {
      console.log(error);
      dispatch(setAppLoading(false));
    }
  };

  // path is a state used here as for setting the active item.
  useEffect(() => {
    switch (true) {
      case "/":
        setPath("1");
        break;
      case homeRoutes.some((routeObj) => matchRoute(routeObj.route)):
        setPath("1");
        break;
      case location.pathname.startsWith("/quotes"):
        setPath("2");
        break;
      case location.pathname.startsWith("/jobs"):
        setPath("2");
        break;
      case location.pathname.startsWith("/booking"):
        setPath("3");
        break;
      case location.pathname.startsWith("/myjobs"):
        setPath("3");
        break;
      case location.pathname.startsWith("/my-garage"):
        setPath("4");
        break;
      case location.pathname.startsWith("/chats"):
        setPath("5");
        break;
      case location.pathname.startsWith("/posts"):
        setPath("6");
        break;
      case location.pathname.startsWith("/reviews"):
        setPath("7");
        break;
      case location.pathname.startsWith("/settings/editProfile"):
        setPath("8");
        break;
      case location.pathname.startsWith("/settings"):
        setPath("9");
        break;
      case location.pathname.startsWith("/notifications"):
        setPath("11");
        break;
      default:
        setPath("1");
        break;
    }
  }, [location.pathname]);

  // dropdown items
  // path is a state used here as for setting the active item.
  const items = [
    {
      key: 8,
      label: (
        <Link className="flex items-center gap-4">
          <IoMdPerson color={Colors.AppYellow} size={16} />
          <span style={{ color: path == "8" ? Colors.AppYellow : "black" }}>
            Edit Profile
          </span>
        </Link>
      ),
      onClick: () => handleDropDownMenuClick("8"),
      route: "settings/editProfile",
    },
    {
      label: <div className="border-b border-dashed w-full"></div>,
    },
    {
      key: 9,
      label: (
        <Link className="flex items-center gap-4">
          <IoIosSettings size={16} color="black" />
          <span style={{ color: path == "9" ? Colors.AppYellow : "black" }}>
            Settings
          </span>
        </Link>
      ),
      onClick: () => handleDropDownMenuClick("9"),
      route: "settings",
    },
    {
      label: <div className="border-b border-dashed w-full"></div>,
    },
    {
      key: 10,
      label: (
        <Link className="flex items-center gap-4">
          <IoLogOutSharp size={16} color="#fb0156" />
          <span>Logout</span>
        </Link>
      ),
      onClick: () => handleDropDownMenuClick("10"),
      route: "logout",
    },
  ];

  // sidebar items
  const mobileMenu = useMemo(
    () => [
      {
        key: 1,
        icon: (
          <MdHomeFilled size={20} color="#6b7280" className="menu-item-text" />
        ),
        label: <span className="text-gray-500 menu-item-text">Home</span>,
        route: "/",
      },
      {
        key: 2,
        icon: (
          <RiFileTextLine
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: <span className="text-gray-500 menu-item-text">My Quotes</span>,
        route: "quotes",
      },
      {
        key: 3,
        icon: (
          <RiCalendarScheduleFill
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: (
          <span className="text-gray-500 menu-item-text">My Bookings</span>
        ),
        route: "booking/my-bookings",
      },
      {
        key: 4,
        icon: (
          <BiSolidCarGarage
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: <span className="text-gray-500 menu-item-text">My Garage</span>,
        route: "my-garage",
      },
      {
        key: 5,
        icon: <ChatUnreadMsgNotificationIcon />,
        label: (
          <span
            className="text-gray-500 menu-item-text"
            onClick={() => dispatch(setNavigateToChannel(false))}
          >
            Chat
          </span>
        ),
        route: "chats",
      },
      {
        key: 6,
        icon: (
          <RiImageEditFill
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: <span className="text-gray-500 menu-item-text">Posts</span>,
        route: "posts",
      },
      {
        key: 7,
        icon: (
          <MdReviews size={20} color="#6b7280" className="menu-item-text" />
        ),
        label: <span className="text-gray-500 menu-item-text">Reviews</span>,
        route: "reviews",
      },
      {
        key: 11,
        icon: <FaBell size={20} color="#6b7280" className="menu-item-text" />,
        label: (
          <span className="text-gray-500 menu-item-text">Notifications</span>
        ),
        route: "notifications",
      },
    ],
    [],
  );

  // sidebar items
  const webMenu = useMemo(
    () => [
      {
        key: 1,
        icon: (
          <MdHomeFilled size={20} color="#6b7280" className="menu-item-text" />
        ),
        label: <span className="text-gray-500 menu-item-text">Home</span>,
        route: "/",
      },
      {
        key: 2,
        icon: (
          <RiFileTextLine
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: <span className="text-gray-500 menu-item-text">My Quotes</span>,
        route: "quotes",
      },
      {
        key: 3,
        icon: (
          <RiCalendarScheduleFill
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: (
          <span className="text-gray-500 menu-item-text">My Bookings</span>
        ),
        route: "booking/my-bookings",
      },
      {
        key: 4,
        icon: (
          <BiSolidCarGarage
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: <span className="text-gray-500 menu-item-text">My Garage</span>,
        route: "my-garage",
      },
      {
        key: 5,
        icon: <ChatUnreadMsgNotificationIcon />,
        label: (
          <span
            className="text-gray-500 menu-item-text"
            onClick={() => dispatch(setNavigateToChannel(false))}
          >
            Chat
          </span>
        ),
        route: "chats",
      },
      {
        key: 6,
        icon: (
          <RiImageEditFill
            size={20}
            color="#6b7280"
            className="menu-item-text"
          />
        ),
        label: <span className="text-gray-500 menu-item-text">Posts</span>,
        route: "posts",
      },
      {
        key: 7,
        icon: (
          <MdReviews size={20} color="#6b7280" className="menu-item-text" />
        ),
        label: <span className="text-gray-500 menu-item-text">Reviews</span>,
        route: "reviews",
      },
    ],
    [],
  );

  const selectItemHandler = (info, deviceType) => {
    let itemkey = info.key;
    setPath(itemkey);
    if (drawerOpen) setDrawerOpen(false);
    let selectedItem =
      deviceType === "web"
        ? webMenu.find((item) => item.key == itemkey)
        : mobileMenu.find((item) => item.key == itemkey);
    if (selectedItem.route !== "/") navigate(`/${selectedItem.route}`);
    else navigate("/");
  };

  const handleDropDownMenuClick = (info) => {
    setPath(info);
    if (drawerOpen) setDrawerOpen(false);
    let selectedItem = items.find((item) => item.key == info);
    if (selectedItem.route !== "logout") navigate(`/${selectedItem.route}`);
    else {
      // here we will write the logout logic
      handleLogout();
    }
  };

  // a function created just to navigate back the user to the home page that is '/' if
  // a user is navigate to some other page from the home page. same as a back button.
  const menuHandler = () => {
    if (homeRoutes.some((routeObj) => matchRoute(routeObj.route))) {
      navigate("/");
      setPath("1");
    } else {
      return;
    }
  };

  return (
    <>
      <Header className="bg-white border-b border-gray-300 h-20 flex items-center justify-between p-3">
        <div className="w-full max-w-7xl mx-auto flex items-center py-5 h-full pl-4 md:px-8">
          <div className=" flex-1">
            <Link to={"/"}>
              <img
                src={HeaderLogo}
                alt="logo"
                className="w-44 md:w-48 h-14 cursor-pointer object-contain"
              />
            </Link>
          </div>
          <div className="flex-1 flex items-center gap-4 justify-end">
            <DownloadButton onClick={handleAdsExternalRedirect} />
            <div className="hidden md:flex h-11 w-11 border rounded-full items-center justify-center relative">
              <Link to={"/notifications"}>
                <FaBell
                  size={23}
                  color="#78919e"
                  className={`${unreadNotifications && unreadNotifications.length && "bell-icon"}`}
                />
              </Link>
              {unreadNotifications && unreadNotifications.length ? (
                <div className="w-3 h-3 rounded-full absolute z-20 top-0 right-0 bg-[#fab700]"></div>
              ) : null}
            </div>

            <div className="hidden md:flex h-11 w-11 border rounded-full items-center justify-center">
              <Link to={"/settings"}>
                <IoIosSettings size={23} color="#78919e" className="cog-icon" />
              </Link>
            </div>
            <div className="h-11 border rounded-md hidden md:block">
              <Dropdown
                menu={{ items }}
                className="group w-44 h-full flex items-center justify-between px-2 py-0 cursor-pointer"
              >
                <div className="flex gap-1 items-center">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <Avatar
                      src={profileData?.imageUrl || loggedInUser?.imageUrl}
                      className="flex items-center justify-center border border-[#FAB700]"
                      shape="circle"
                    >
                      {getInitials(profileData?.fullName || loggedInUser?.fullName)}
                    </Avatar>
                  </div>
                  <span className="text-ellipsis truncate text-dark">
                    <Tooltip
                      title={
                        profileData?.fullName || loggedInUser?.fullName ? profileData?.fullName || loggedInUser?.fullName : "-"
                      }
                    >
                      Hello{" "}
                      {profileData?.fullName || loggedInUser?.fullName ? profileData?.fullName || loggedInUser?.fullName : "-"}
                    </Tooltip>
                  </span>
                  <CaretRightOutlined className="group-hover:hidden inline" />
                  <CaretDownOutlined className="group-hover:inline hidden" />
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
        <FiMenu
          className="inline md:hidden ml-6"
          color="#78919e"
          onClick={drawerOpenHandler}
          size={27}
        />
      </Header>

      <Header className="bg-white hidden md:flex h-20 border">
        <div className="w-full max-w-6xl mx-auto flex items-center py-5 h-full justify-center">
          <Menu
            mode="inline"
            selectedKeys={[path]}
            className="flex justify-between w-full"
            onSelect={(info) => selectItemHandler(info, "web")}
            items={webMenu}
            onClick={menuHandler}
          />
        </div>
      </Header>

      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width={250}
      >
        <div className="h-11 border rounded-md">
          <Dropdown
            menu={{ items }}
            className="group w-44 h-full flex items-center justify-between px-2 py-0 cursor-pointer"
          >
            <div className="flex gap-1">
              <div className="w-10 h-10 flex items-center justify-center">
                <Avatar
                  icon={<UserOutlined />}
                  className="flex items-center justify-center"
                  shape="circle"
                />
              </div>
              <span className="text-ellipsis truncate text-dark">
                <Tooltip title={profileData?.userDetail?.businessName}>
                  {profileData?.userDetail?.businessName}
                </Tooltip>
              </span>
              <CaretRightOutlined className="group-hover:hidden inline" />
              <CaretDownOutlined className="group-hover:inline hidden" />
            </div>
          </Dropdown>
        </div>
        <Divider />
        <div className="w-full mx-auto flex justify-start">
          <Menu
            mode=""
            selectedKeys={[path]}
            className="flex justify-start gap-5 w-full flex-col text-lg custom-drawer-menu-styling"
            onSelect={(info) => selectItemHandler(info, "mobile")}
            items={mobileMenu}
            onClick={menuHandler}
          />
        </div>
      </Drawer>
    </>
  );
};
export default ServiceProviderHeader;
